import { Component, Input, OnInit } from '@angular/core';
import { PieChartData } from 'app/components/new-navigation/charts/models/PieChartData';
import {
  Breakpoint,
  MediaQueryService
} from 'app/services/media-query.service';
import { Observable } from 'rxjs';

declare var jQuery;

@Component({
  selector: 'app-contribution-platform',
  templateUrl: './app-contribution-platform.html',
  styleUrls: ['./app-contribution-platform.scss']
})
export class AppContributionPlatform implements OnInit {
  @Input() data;
  mobile$: Observable<boolean>;

  tooltip: any = {};
  devicePieChartData: Array<PieChartData> = [];
  colors = [
    '#4BC47C',
    '#C2E7CF',
    '#2E7D32',
    '#EAF6ED',
    '#00BDFF',
    '#002F40',
    '#00AAE5',
    '#66d9ff'
  ];

  constructor(private mediaQueryService: MediaQueryService) {}

  ngOnInit() {
    this.mobile$ = this.mediaQueryService.lte(Breakpoint.md);

    setTimeout(fn => {
      jQuery('[enTooltip]').tooltip({ animation: false });
    }, 100);

    this.devicePieChartData = this?.data?.engagementMetrics?.byDevice
      .filter(item => item.inventoryRatio > 0)
      .map(item => {
        return {
          category: item?.device,
          value: item?.inventoryRatio,
          title: item?.device
        };
      });
  }
}
